import React, { useEffect, useState } from 'react';
import { Card, CardHeader } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import { FaArrowLeft } from "react-icons/fa";
import Select from 'react-select';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import { DefaultSettingServices } from "../../services/DefaultSettingServices";
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from '../components/customStyles';
import '../custom.css';
import { isMobile } from '../../util/GeneralUtil';
import { NumberToWordFormatter } from '../components/NumberToWordFormatter';


function Defaultsetting() {

    var adminId = BullCache.getFromCache("user");
    var allScripts = BullCache.getFromCache('allScripts');

    const [isAddingSetting, setIsAddingSetting] = useState(false);

    const [isCheckedGlobal, setIsCheckedGlobal] = useState(false);
    const [isCheckedNSE, setIsCheckedNSE] = useState(false);
    const [isCheckedMCX, setIsCheckedMCX] = useState(false);
    const [isCheckedNCDEX, setIsCheckedNCDEX] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalMCX, setShowModalMCX] = useState(false);
    const [showModalNSE, setShowModalNSE] = useState(false);
    const [showModalNCDEX, setShowModalNCDEX] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedOptionMCX, setSelectedOptionMCX] = useState(null);
    const [selectedOptionNSE, setSelectedOptionNSE] = useState(null);
    const [selectedOptionNCDEX, setSelectedOptionNCDEX] = useState(null);
    const [subBrokerDropdown, setSubBrokerDropdown] = useState(null);
    const [copySettingOptions, setCopySettingOptions] = useState([]);
    const [
        copySettingINDEXForBrokerageDetails,
        setCopySettingINDEXForBrokerageDetails,
      ] = useState(null);
      const [
        copySettingINDEXForMarginDetails,
        setCopySettingINDEXForMarginDetails,
      ] = useState(null);
      const [copySettingINDEXForOtherDetails, setCopySettingINDEXForOtherDetails] =
        useState(null);
        const [
            copySettingNSEForBrokerageDetails,
            setCopySettingNSEForBrokerageDetails,
          ] = useState(null);
          const [copySettingNSEForMarginDetails, setCopySettingNSEForMarginDetails] =
            useState(null);
          const [copySettingNSEForOtherDetails, setCopySettingNSEForOtherDetails] =
            useState(null);
        
          const [
            copySettingMCXForBrokerageDetails,
            setCopySettingMCXForBrokerageDetails,
          ] = useState(null);
          const [copySettingMCXForMarginDetails, setCopySettingMCXForMarginDetails] =
            useState(null);
          const [copySettingMCXForOtherDetails, setCopySettingMCXForOtherDetails] =
            useState(null);
            const [blockedScriptDropdownIndex, setBlockedScriptDropdownIndex] = useState(
                []
              );   
              const [scriptDeatailsDropdownIndex, setScriptDeatailsDropdownIndex] =
              useState([]);
              const [
                scriptDetailsIndexRadioSelection,
                setScriptDetailsIndexRadioSelection,
              ] = useState("ALLOW");
    const [inputFields, setInputFields] = useState([
      { id: Date.now(), selectedScript: 'ALL', deliveryCom: '', intradayCom: '' }]);
    const [inputFieldsNSE, setInputFieldsNSE] = useState([
        { id: Date.now(), selectedScript: 'ALL', deliveryCom: '', intradayCom: '' }]);
    const [inputFieldsMCX, setInputFieldsMCX] = useState([
        { id: Date.now(), selectedScript: 'ALL', deliveryCom: '', intradayCom: '' }]);
    const [inputFieldsNCDEX, setInputFieldsNCDEX] = useState([
        { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }]);
    const [segments, setSegments] = useState([]);

    const adminChange2 = (e) => {
        setSelectedRole(e.target.value);
    };
    const handleAddSettingClick = () => {
        setIsAddingSetting(true);
    };
    const handleBackButtonClick = () => {
        setIsAddingSetting(false);
        setFormData({ settingName: '' });
        setSelectedOptionDefault(null);

        setFormData({
            settingName: '',
            partnership: '',
            brokerage: '',
            alert: '',
            orderLimit: '',
            squareOffDisabledInMin: '',
            m2mLoss: '',
            m2mProfit: '',
            tradeBlockAbove: '',
            tradeBlockBelow: '',
            segments: []
        });

        setIsCheckedGlobal(false);
        setIsCheckedMCX(false);
        setIsCheckedNSE(false);
        setIsCheckedNCDEX(false);

        setInputFields([]);
        setInputFieldsMCX([]);
        setInputFieldsNSE([]);
        setInputFieldsNCDEX([]);

        setSelectedOptionDefault(null);
        setMarginDetails({ lot: '', amount: '' });
        setMarginDetailsMCX({ lot: '', amount: '' });
        setMarginDetailsNSE({ lot: '', amount: '' });
        setMarginDetailsNCDEX({ lot: '', amount: '' });

        setOrderHighLow(false);
        setAutoSquare(false);
        setIntraDayAutoSquare(false);
        setOnlyPositionSquare(false);
        setRollOver(true);
        setOnlyViewAccess(false);
        setBandScriptAllow(false);
        setLedgerView(true);
        setTradeAllowed(true);

    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        if (name === 'global') {
            setIsCheckedGlobal(checked);
        } else if (name === 'nse') {
            setIsCheckedNSE(checked);
        } else if (name === 'mcx') {
            setIsCheckedMCX(checked);
        }
        else if (name === 'ncdex') {
            setIsCheckedNCDEX(checked);
        }

    };

    useEffect(() => {
        let updatedSegments = [];

        if (isCheckedGlobal) updatedSegments.push('global');
        if (isCheckedNSE) updatedSegments.push('nse');
        if (isCheckedMCX) updatedSegments.push('mcx');

        setSegments(updatedSegments);
    }, [isCheckedGlobal, isCheckedNSE, isCheckedMCX, isCheckedNCDEX]);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    const handleOpenModalMCX = () => {
        setShowModalMCX(true);
    };

    const handleCloseModalMCX = () => {
        setShowModalMCX(false);
    };
    const handleOpenModalNSE = () => {
        setShowModalNSE(true);
    };

    const handleCloseModalNSE = () => {
        setShowModalNSE(false);
    };
    const handleOpenModalNCDEX = () => {
        setShowModalNCDEX(true);
    };

    const handleCloseModalNCDEX = () => {
        setShowModalNCDEX(false);
    };
    const [selectedOptionDefault, setSelectedOptionDefault] = useState('');
    const [optionsDefaultSetting, setOptionsDefaultSetting] = useState([]);
    const handleCopySettingDropdownINDEXForBrokerageDetails = (selected) => {
        setCopySettingINDEXForBrokerageDetails(selected);
      };
      const handleCopySettingDropdownINDEXForMarginDetails = (selected) => {
        setCopySettingINDEXForMarginDetails(selected);
      };
      const handleCopySettingDropdownINDEXForOtherDetails = (selected) => {
        setCopySettingINDEXForOtherDetails(selected);
      };
    
      const handleCopySettingDropdownMCXorBrokerageDetails = (selected) => {
        setCopySettingMCXForBrokerageDetails(selected);
      };
      const handleCopySettingDropdownMCXForMarginDetails = (selected) => {
        setCopySettingMCXForMarginDetails(selected);
      };
      const handleCopySettingDropdownMCXForOtherDetails = (selected) => {
        setCopySettingMCXForOtherDetails(selected);
      };
      const handleCopySettingDropdownNSEForBrokerageDetails = (selected) => {
        setCopySettingNSEForBrokerageDetails(selected);
      };
      const handleCopySettingDropdownNSEForMarginDetails = (selected) => {
        setCopySettingNSEForMarginDetails(selected);
      };
      const handleCopySettingDropdownNSEForOtherDetails = (selected) => {
        setCopySettingNSEForOtherDetails(selected);
      };
      const handleBlockedScriptDropdownIndex = (selectedOptions) => {
        setBlockedScriptDropdownIndex(
          selectedOptions ? selectedOptions.map((option) => option.value) : []
        );
      };
      const handleScriptDetailsDropdownINDEX = (selectedOptions) => {
        setScriptDeatailsDropdownIndex(
          selectedOptions ? selectedOptions?.map((option) => option.value) : []
        );
      };
    
    useEffect(() => {
        DefaultSettingServices.getSettings({ 'adminId': adminId.adminId }).then(res => {
            if (res.code === 1) {
                if (res.data.settingList.length > 0) {
                    setOptionsDefaultSetting(res.data.settingList);

                }
                else {
                    setOptionsDefaultSetting([]);
                }
            }
        });
    }, []);
    const optionsDefault = optionsDefaultSetting.map(item => ({
        value: item.settingId,
        label: item.settingName
    }));

    const handleSelectChange = (selected) => {
        setSelectedOptionDefault(selected);
        if (selected) {
            const selectedSetting = optionsDefaultSetting.find(item => item.settingId === selected.value);

            setFormData({
                settingName: selectedSetting.settingName || '',
                partnership: selectedSetting.accountDetails?.partnership || '',
                brokerage: selectedSetting.accountDetails?.brokerage || '',
                alert: selectedSetting.accountDetails?.alert || '',
                orderLimit: selectedSetting.accountDetails?.orderLimit || '',
                squareOffDisabledInMin: selectedSetting.accountDetails?.squareOffDisabledInMin || '',
                m2mLoss: selectedSetting.accountDetails?.m2mLoss || '',
                m2mProfit: selectedSetting.accountDetails?.m2mProfit || '',
                tradeBlockAbove: selectedSetting.accountDetails?.tradeBlockAbove || '',
                tradeBlockBelow: selectedSetting.accountDetails?.tradeBlockBelow || '',
            });


            if (selectedSetting.segments) {
                if (selectedSetting.segments.includes("global")) {
                    setIsCheckedGlobal(true);
                }
                if (selectedSetting.segments.includes("mcx")) {
                    setIsCheckedMCX(true);
                }
                if (selectedSetting.segments.includes("nse")) {
                    setIsCheckedNSE(true);
                }
                if (selectedSetting.segments.includes("ncdex")) {
                    setIsCheckedNCDEX(true);
                }
            }

            if (selectedSetting.marketAccess && selectedSetting.marketAccess.globalSetting && selectedSetting.marketAccess.globalSetting) {
                const brokerageDetails = selectedSetting.marketAccess.globalSetting.brokerageDetails;
                const updatedFields = brokerageDetails.map(item => ({
                    id: uuidv4(),
                    selectedScript: item.script,
                    deliveryCom: item.deliveryCom,
                    intradayCom: item.intradayCom
                }));

                setInputFields(updatedFields);
                setRadioSelection(brokerageDetails[0].type)
                // if (brokerageDetails) {
                //     const { type } = brokerageDetails.type;

                //     // Set margin type (LOT or AMOUNT) based on the API response
                //     if (type === 'lot') {
                //         setRadioSelection('LOT');  // Automatically select LOT radio button if lot is available
                //     } else if (type !== 'percent') {
                //         setRadioSelection('PERCENT');  // Automatically select PERCENT if amount is available
                //     }
                // }

                const handleDeleteindex = (idToDelete) => {
                    const updatedFields = inputFields.filter(item => item.id !== idToDelete);
                    setInputFields(updatedFields);
                };
                const { lot, amount } =
                selectedSetting.marketAccess.globalSetting.marginDetails || {};
              setMarginDetails({ lot, amount });
              setMarginDetailsINEDXLot(lot);
              setMarginDetailsINDEXAmount(amount);
              if (lot > 0) {
                setMarginDetailsRadioSelection("LOT");
                setMarginDetailsDelivery(lot);
              } else if (amount > 0) {
                setMarginDetailsRadioSelection("AMOUNT");
                setMarginDetailsDelivery(amount);
              }
      
              const scriptDetailsindex =
              selectedSetting.marketAccess.globalSetting.otherDetails || {};
              const blockedScriptsindex = scriptDetailsindex.blockedScripts || [];
              const allowedScriptsindex = scriptDetailsindex.allowedScripts || [];
      
              const blockedScriptOptionsindex = blockedScriptsindex.map((script) => ({
                value: script,
                label: script,
              }));
              const allowedScriptOptionsindex = allowedScriptsindex.map((script) => ({
                value: script,
                label: script,
              }));
      
              if (blockedScriptsindex.length > 0) {
                setScriptDetailsRadioSelection("BLOCK");
                setBlockedScriptDropdownIndex(
                  blockedScriptOptionsindex.map((script) => script.value)
                );
              } 
              if(allowedScriptsindex?.length>0) {
                setScriptDetailsRadioSelection("ALLOW");
                setScriptDeatailsDropdownIndex(
                  allowedScriptOptionsindex.map((script) => script.value)
                );
              }
            }
            if (selectedSetting.marketAccess && selectedSetting.marketAccess.mcxSetting && selectedSetting.marketAccess.mcxSetting) {
                const brokerageDetails = selectedSetting.marketAccess.mcxSetting.brokerageDetails;

                const updatedFields = brokerageDetails.map(item => ({
                    id: uuidv4(),
                    selectedScript: item.script,
                    deliveryCom: item.deliveryCom,
                    intradayCom: item.intradayCom
                }));

                setInputFieldsMCX(updatedFields);
                setRadioSelectionMCX(selectedSetting.marketAccess.mcxSetting.type)
                const handleDelete = (idToDelete) => {
                    const updatedFields = inputFieldsMCX.filter(item => item.id !== idToDelete);
                    setInputFieldsMCX(updatedFields);
                };
                const { lot, amount } =
                selectedSetting.marketAccess.mcxSetting.marginDetails || {};
              setMarginDetailsMCX({ lot, amount });
              setMarginDetailsMCXLot(lot);
              setMarginDetailsMCXAmount(amount);
      
              if (lot > 0) {
                setMarginDetailsRadioSelectionMCX("LOT");
                setMarginDetailsDeliveryMCX(lot);
              } else if (amount > 0) {
                setMarginDetailsRadioSelectionMCX("AMOUNT");
                setMarginDetailsDeliveryMCX(amount);
              }
              const scriptDetails =
                selectedSetting.marketAccess.mcxSetting.otherDetails || {};
              const blockedScripts = scriptDetails.blockedScripts || [];
              const allowedScripts = scriptDetails.allowedScripts || [];
      
              const blockedScriptOptions = blockedScripts.map((script) => ({
                value: script,
                label: script,
              }));
              const allowedScriptOptions = allowedScripts.map((script) => ({
                value: script,
                label: script,
              }));
      
              if (blockedScripts.length > 0) {
                setScriptDetailsRadioSelectionMCX("BLOCK");
                setBlockedScriptDropdownMCX(
                  blockedScriptOptions.map((script) => script.value)
                );
              } 
              if(allowedScripts?.length>0) {
                setScriptDetailsRadioSelectionMCX("ALLOW");
                setScriptDeatailsDropdownMCX(
                  allowedScriptOptions.map((script) => script.value)
                );
              }
            }

            if (selectedSetting.marketAccess && selectedSetting.marketAccess.nseSetting && selectedSetting.marketAccess.nseSetting) {
                const brokerageDetails = selectedSetting.marketAccess.nseSetting.brokerageDetails;

                const updatedFields = brokerageDetails.map(item => ({
                    id: uuidv4(),
                    selectedScript: item.script,
                    deliveryCom: item.deliveryCom,
                    intradayCom: item.intradayCom
                }));

                setInputFieldsNSE(updatedFields);
                setRadioSelectionMCX(selectedSetting.marketAccess.nseSetting.type)
                const handleDeletense = (idToDelete) => {
                    const updatedFields = inputFieldsNSE.filter(item => item.id !== idToDelete);
                    setInputFieldsNSE(updatedFields);
                };
                const { lot, amount } =
                selectedSetting.marketAccess.nseSetting.marginDetails || {};
              // setMarginDetailsNSE({ lot, amount });
              setMarginDetailsNSELot(lot);
              setMarginDetailsNSEAmount(amount);
      
              if (lot > 0) {
                setMarginDetailsRadioSelectionNSE("LOT");
                setMarginDetailsDeliveryNSE(lot);
              } else if (amount > 0) {
                setMarginDetailsRadioSelectionNSE("AMOUNT");
                setMarginDetailsDeliveryNSE(amount);
              }
      
              const scriptDetailsnse =
                selectedSetting.marketAccess.nseSetting.otherDetails || {};
              const blockedScriptsnse = scriptDetailsnse.blockedScripts || [];
              const allowedScriptsnse = scriptDetailsnse.allowedScripts || [];
      
              const blockedScriptOptionsnse = blockedScriptsnse.map((script) => ({
                value: script,
                label: script,
              }));
              const allowedScriptOptionsnse = allowedScriptsnse.map((script) => ({
                value: script,
                label: script,
              }));
      
              if (blockedScriptsnse.length > 0) {
                setScriptDetailsRadioSelectionNSE("BLOCK");
                setBlockedScriptDropdownNSE(
                  blockedScriptOptionsnse.map((script) => script.value)
                );
              } 
              if(allowedScriptsnse?.length>0) {
                setScriptDetailsRadioSelectionNSE("ALLOW");
                setScriptDeatailsDropdownNSE(
                  allowedScriptOptionsnse.map((script) => script.value)
                );
              }
            }

            setOrderHighLow(selectedSetting.accountDetails.orderHighLow || false);
            setAutoSquare(selectedSetting.accountDetails.applyAutoSquare || false);
            setIntraDayAutoSquare(selectedSetting.accountDetails.intradaySquare || false);
            setOnlyPositionSquare(selectedSetting.accountDetails.onlyPositionSquareOff || false);
            setRollOver(selectedSetting.accountDetails.rollOver || false);
            setOnlyViewAccess(selectedSetting.accountDetails.onlyViewAccess || false);
            setBandScriptAllow(selectedSetting.accountDetails.bandScriptAllow || false);
            setLedgerView(selectedSetting.accountDetails.ledgerView || false);
            setTradeAllowed(selectedSetting.accountDetails.tradeAllowed || false);
            setm2mLinkWithLedger(selectedSetting.accountDetails.m2mLinkWithLedger || false);



        }
        else {
            setFormData({
                settingName: '',
                partnership: '',
                brokerage: '',
                alert: '',
                orderLimit: '',
                squareOffDisabledInMin: '',
                m2mLoss: '',
                m2mProfit: '',
                tradeBlockAbove: '',
                tradeBlockBelow: '',
                segments: []
            });

            // Reset checkboxes and other state
            setIsCheckedGlobal(false);
            setIsCheckedMCX(false);
            setIsCheckedNSE(false);
            setIsCheckedNCDEX(false);

            // Clear dynamic input fields
            setInputFields([]);
            setInputFieldsMCX([]);
            setInputFieldsNSE([]);
            setInputFieldsNCDEX([]);

            // Clear margin details
            setMarginDetails({ lot: '', amount: '' });
            setMarginDetailsMCX({ lot: '', amount: '' });
            setMarginDetailsNSE({ lot: '', amount: '' });
            setMarginDetailsNCDEX({ lot: '', amount: '' });

            // Reset flags
            setOrderHighLow(false);
            setAutoSquare(false);
            setIntraDayAutoSquare(false);
            setOnlyPositionSquare(false);
            setRollOver(false);
            setOnlyViewAccess(false);
            setBandScriptAllow(false);
            setLedgerView(true);
            setTradeAllowed(false);
        }
    };



    // const [copySetting, setCopySetting] = useState(null);
    const [customer, setCustomer] = useState([]);
    const [master, setMaster] = useState([]);
    const [broker, setBroker] = useState([]);
    const [brokerageScripts, setBrokerageScripts] = useState([]);
    const [brokerageDropdown, setBrokerageDropdown] = useState([]);
    const [scriptDeatailsDropdown, setScriptDeatailsDropdown] = useState([]);
    const [scriptDetailsScript, setScriptDetailsScript] = useState([]);
    const [blockedScriptDropdown, setBlockedScriptDropdown] = useState([]);
    const [blockedScriptDetails, setBlockedScriptDetails] = useState([]);
    const [radioSelection, setRadioSelection] = useState('PERCENT');
    const [marginDetailsRadioSelection, setMarginDetailsRadioSelection] = useState('AMOUNT');
    const [marginDetailsINDEXLot, setMarginDetailsINEDXLot] = useState();
  const [marginDetailsINDEXAmount, setMarginDetailsINDEXAmount] = useState();
    const [marginDetailsCopySetting, setMarginDetailsCopySetting] = useState('');
    const [marginDetailsDelivery, setMarginDetailsDelivery] = useState('');
    const [marginDetails, setMarginDetails] = useState({});
    const [scriptDetailsRadioSelection, setScriptDetailsRadioSelection] = useState('');
    const [allowedScripts, setAllowedScripts] = useState([]);
    const [blockedScripts, setBlockedScripts] = useState([]);

    const [brokerageScriptsMCX, setBrokerageScriptsMCX] = useState([]);
    const [brokerageDropdownMCX, setBrokerageDropdownMCX] = useState([]);
    const [scriptDeatailsDropdownMCX, setScriptDeatailsDropdownMCX] = useState([]);
    const [scriptDetailsScriptMCX, setScriptDetailsScriptMCX] = useState([]);
    const [blockedScriptDropdownMCX, setBlockedScriptDropdownMCX] = useState([]);
    const [blockedScriptDetailsMCX, setBlockedScriptDetailsMCX] = useState([]);
    const [deliveryComMCX, setDeliveryComMCX] = useState('');
    const [intradayComMCX, setIntradayComMCX] = useState('');
    const [radioSelectionMCX, setRadioSelectionMCX] = useState('LOT');
    const [marginDetailsRadioSelectionMCX, setMarginDetailsRadioSelectionMCX] = useState('LOT');
    const [marginDetailsCopySettingMCX, setMarginDetailsCopySettingMCX] = useState('');
    const [marginDetailsDeliveryMCX, setMarginDetailsDeliveryMCX] = useState('');
    const [marginDetailsMCX, setMarginDetailsMCX] = useState({});
    const [scriptDetailsRadioSelectionMCX, setScriptDetailsRadioSelectionMCX] = useState('ALLOW');
    const [allowedScriptsMCX, setAllowedScriptsMCX] = useState([]);
    const [blockedScriptsMCX, setBlockedScriptsMCX] = useState([]);

    const [brokerageScriptsNSE, setBrokerageScriptsNSE] = useState([]);
    const [brokerageDropdownNSE, setBrokerageDropdownNSE] = useState([]);
    const [scriptDeatailsDropdownNSE, setScriptDeatailsDropdownNSE] = useState([]);
    const [scriptDetailsScriptNSE, setScriptDetailsScriptNSE] = useState([]);
    const [blockedScriptDropdownNSE, setBlockedScriptDropdownNSE] = useState([]);
    const [blockedScriptDetailsNSE, setBlockedScriptDetailsNSE] = useState([]);
    const [deliveryComNSE, setDeliveryComNSE] = useState('');
    const [intradayComNSE, setIntradayComNSE] = useState('');
    const [radioSelectionNSE, setRadioSelectionNSE] = useState('PERCENT');
    const [marginDetailsRadioSelectionNSE, setMarginDetailsRadioSelectionNSE] = useState('AMOUNT');
    const [marginDetailsCopySettingNSE, setMarginDetailsCopySettingNSE] = useState('');
    const [marginDetailsDeliveryNSE, setMarginDetailsDeliveryNSE] = useState('');
    const [marginDetailsNSE, setMarginDetailsNSE] = useState({});
    const [scriptDetailsRadioSelectionNSE, setScriptDetailsRadioSelectionNSE] = useState('ALLOW');
    const [allowedScriptsNSE, setAllowedScriptsNSE] = useState([]);
    const [blockedScriptsNSE, setBlockedScriptsNSE] = useState([]);

    const [brokerageScriptsNCDEX, setBrokerageScriptsNCDEX] = useState([]);
    const [brokerageDropdownNCDEX, setBrokerageDropdownNCDEX] = useState([]);
    const [scriptDeatailsDropdownNCDEX, setScriptDeatailsDropdownNCDEX] = useState([]);
    const [scriptDetailsScriptNCDEX, setScriptDetailsScriptNCDEX] = useState([]);
    const [blockedScriptDropdownNCDEX, setBlockedScriptDropdownNCDEX] = useState([]);
    const [blockedScriptDetailsNCDEX, setBlockedScriptDetailsNCDEX] = useState([]);
    const [deliveryComNCDEX, setDeliveryComNCDEX] = useState('');
    const [intradayComNCDEX, setIntradayComNCDEX] = useState('');
    const [radioSelectionNCDEX, setRadioSelectionNCDEX] = useState('');
    const [marginDetailsRadioSelectionNCDEX, setMarginDetailsRadioSelectionNCDEX] = useState('LOT');
    const [marginDetailsCopySettingNCDEX, setMarginDetailsCopySettingNCDEX] = useState('');
    const [marginDetailsDeliveryNCDEX, setMarginDetailsDeliveryNCDEX] = useState('');
    const [marginDetailsNCDEX, setMarginDetailsNCDEX] = useState({});
    const [scriptDetailsRadioSelectionNCDEX, setScriptDetailsRadioSelectionNCDEX] = useState('ALLOW');
    const [allowedScriptsNCDEX, setAllowedScriptsNCDEX] = useState([]);
    const [blockedScriptsNCDEX, setBlockedScriptsNCDEX] = useState([]);

    const [subBroker, setSubBroker] = useState([]);
    const [selectBrokerPartner, setSelectBrokerPartner] = useState('');
    const [orderHighLow, setOrderHighLow] = useState(false);
    const [applyAutoSquare, setAutoSquare] = useState(false);
    const [tradeAllowed, setTradeAllowed] = useState(true);
    const [intraDayAutoSquare, setIntraDayAutoSquare] = useState(false);
    const [onlyPositionSquareOff, setOnlyPositionSquare] = useState(false);
    const [rollOver, setRollOver] = useState(true);
    const [onlyViewAccess, setOnlyViewAccess] = useState(false);
    const [bandScriptAllow, setBandScriptAllow] = useState(false);
    const [ledgerView, setLedgerView] = useState(true);
    const [selectedBroker, setSelectedBroker] = useState('');
    const [editData, setEditData] = useState('');
  const [m2mLinkWithLedger, setm2mLinkWithLedger] = useState(false);
  const [mcxFreshLimitAllowed, setMcxFreshLimitAllowed] = useState(true);
  const [indexFreshLimitAllowed, setIndexFreshLimitAllowed] = useState(true);
  const [nseFreshLimitAllowed, setNseFreshLimitAllowed] = useState(true);
  const [mcxScriptToWork, setMCXScriptToWork] = useState();
  const [indexScriptToWork, setIndexScriptToWork] = useState();
  const [NseScriptToWork, setNSEScriptToWork] = useState();
  const [marginDetailsNSELot, setMarginDetailsNSELot] = useState();
  const [marginDetailsNSEAmount, setMarginDetailsNSEAmount] = useState();
  const [marginDetailsMCXLot, setMarginDetailsMCXLot] = useState();
  const [marginDetailsMCXAmount, setMarginDetailsMCXAmount] = useState();
    const [formData, setFormData] = useState({
        settingName: '',
        partnership: '',
        brokerage: '',
        alert: '',
        orderLimit: '',
        squareOffDisabledInMin: '',
        m2mLoss: '',
        m2mProfit: '',
        tradeBlockAbove: '',
        tradeBlockBelow: '',
        // segment: []
    });
    const [errors, setErrors] = useState({
        settingName: ''
    });
    const handleRadioChange = (value) => {
        setLedgerView(value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateField = (name, value) => {
        let errorMessage = '';
        if (name === 'settingName' && !value) {
            errorMessage = '* ';
        }


        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage,
        }));
    };


    useEffect(() => {
      if (adminId.segments.includes("NSE")) {
        const nseData = [];
        for (const category in allScripts.NSE) {
          nseData.push({ label: category, value: category });
        }
        setBrokerageScriptsNSE(nseData);
        setScriptDetailsScriptNSE(nseData);
        setBlockedScriptDetailsNSE(nseData);
        //setScriptDetailsScriptINDEX(nseData);
  
        //setScriptDetailsScript(indexData);
      }
  
      if (adminId.segments.includes("MCX")) {
        const mcxData = [];
        for (const category in allScripts.MCX) {
          mcxData.push({ label: category, value: category });
        }
        setBrokerageScriptsMCX(mcxData);
        setScriptDetailsScriptMCX(mcxData);
        setBlockedScriptDetailsMCX(mcxData);
      }
  
      if (adminId.segments.includes("GLOBAL")) {
        const globalData = [];
        for (const category in allScripts.GLOBAL) {
          globalData.push({ label: category, value: category });
        }
  
        setBrokerageScripts(globalData);
        setScriptDetailsScript(globalData);
        setBlockedScriptDetails(globalData);
      }
    }, [selectedRole]);




    const options = customer.map(customer => ({ value: customer.id, label: `${customer.firstName} ${customer.lastName} (${customer.userName})` }))


    const doNewAccount = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const formObject = Object.fromEntries(formData.entries());

        let brokerageDetailsIndex = [];
        inputFields.forEach(field => {
          if (field.selectedScript) {
            brokerageDetailsIndex.push({
              script: field.selectedScript,
              deliveryCom: parseFloat(field.deliveryCom) || 0,
              intradayCom: parseFloat(field.intradayCom) || 0,
              type: radioSelection || formObject.radioSelection , 
            });
          }
        });
        let brokerageDetailsNSE = [];
        inputFieldsNSE.forEach(field => {
            if (field.selectedScript) {
                brokerageDetailsNSE.push({
                    script: field.selectedScript,
                    deliveryCom: parseFloat(field.deliveryCom) || 0,
                    intradayCom: parseFloat(field.intradayCom) || 0,
                    type:radioSelectionNSE
                });
            }
        });
        let brokerageDetailsMCX = [];
        inputFieldsMCX.forEach(field => {
            if (field.selectedScript) {
                brokerageDetailsMCX.push({
                    script: field.selectedScript,
                    deliveryCom: parseFloat(field.deliveryCom) || 0,
                    intradayCom: parseFloat(field.intradayCom) || 0,
                });
            }
        });
        let brokerageDetailsNCDEX = [];
        inputFieldsNCDEX.forEach(field => {
            if (field.selectedScript) {
                brokerageDetailsNCDEX.push({
                    script: field.selectedScript,
                    deliveryCom: parseFloat(field.deliveryCom) || 0,
                    intradayCom: parseFloat(field.intradayCom) || 0,
                });
            }
        });

        let accountDetails = {
            partnership: formObject.partnership || '',
            orderHighLow: orderHighLow || formObject.orderHighLow || 'false',
            applyAutoSquare: applyAutoSquare || formObject.applyAutoSquare || 'false',
            intradaySquare: intraDayAutoSquare || formObject.intraDayAutoSquare || 'false',
            onlyPositionSquareOff: onlyPositionSquareOff || formObject.onlyPositionSquareOff || 'false',
            rollOver: rollOver || formObject.rollOver || 'false',
            onlyViewAccess: onlyViewAccess || formObject.onlyViewAccess || 'false',
            bandScriptAllow: orderHighLow || formObject.bandScriptAllow || 'false',
            squareOffDisabledInMin: formObject.squareOffDisabledInMin || '',
            alert: formObject.alert || '',
            m2mLoss: formObject.m2mLoss || '',
            orderLimit: formObject.orderLimit || '',
            m2mProfit: formObject.m2mProfit || '',
            m2mLinkWithLedger: m2mLinkWithLedger||formObject.m2mLinkWithLedger || 'false',
            tradeAllowed: tradeAllowed || formObject.tradeAllowed || 'false',
            tradeBlockAbove: formObject.tradeBlockAbove || '',
            tradeBlockBelow: formObject.tradeBlockBelow || '',
            ledgerView: true
        };


        let marketAccess = {};


        if (isCheckedGlobal) {
            marketAccess.globalSetting = {
              type: radioSelection || formObject.radioSelection || '',
                brokerageDetails: brokerageDetailsIndex,
                marginDetails: {
                    lot: marginDetailsINDEXLot,
                    amount: marginDetailsINDEXAmount,
                },
                otherDetails: {
                  allowedScripts: scriptDeatailsDropdownIndex,
                  blockedScripts: blockedScriptDropdownIndex,
                  scriptToWork: indexScriptToWork,
                  freshLimit: indexFreshLimitAllowed,
                },
            };

        }

        if (isCheckedNSE) {

            marketAccess.nseSetting = {
                type: radioSelectionNSE || formObject.radioSelectionNSE || '',
                brokerageDetails: brokerageDetailsNSE,

                marginDetails: {
                    lot: marginDetailsNSELot,
                    amount: marginDetailsNSEAmount,
                },
                otherDetails: {
                  allowedScripts: scriptDeatailsDropdownNSE,
                  blockedScripts: blockedScriptDropdownNSE,
                  scriptToWork: NseScriptToWork,
                  freshLimit: nseFreshLimitAllowed,
                },

            };
        }

        if (isCheckedMCX) {
            marketAccess.mcxSetting = {
                type: radioSelectionMCX || formObject.radioSelectionMCX || '',
                brokerageDetails: brokerageDetailsMCX,

                marginDetails: {
                    lot: marginDetailsMCXLot,
                    amount: marginDetailsMCXAmount,
                },
                otherDetails: {
                  allowedScripts: scriptDeatailsDropdownMCX,
                  blockedScripts: blockedScriptDropdownMCX,
                  scriptToWork: mcxScriptToWork,
                  freshLimit: mcxFreshLimitAllowed,
                },
            };
        }



        const jsonData = {
            settingName: formObject.settingName || selectedOptionDefault?.label || null, // Use settingName from formObject or dropdown label
            segments: segments,
            accountDetails: accountDetails,
            marketAccess: marketAccess,
            remark: formObject.remark,
        };

        if (!formObject.settingName && selectedOptionDefault?.value) {
            jsonData.settingId = selectedOptionDefault.value;  // Add settingId when dropdown value is selected
        }

        jsonData.adminId = adminId.adminId;

        if (formObject.settingName) {
            DefaultSettingServices.addSettings(jsonData)
                .then((resp) => {
                    if (resp.code === 1) {
                        Swal.fire({
                            title: "Success!",
                            text: " Data added successfully.",
                            icon: "success",
                            confirmButtonText: 'Okay'
                        }).then(() => {
                            window.location.reload();
                        });

                    } else {
                        Swal.fire({
                            title: "Error",
                            text: resp.messages,
                            icon: "error"
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Error",
                        text: error,
                        icon: "error"
                    });
                });
        } else {
            DefaultSettingServices.updateSettings(jsonData)
                .then((resp) => {
                    if (resp.code === 1) {
                        Swal.fire({
                            title: "Success!",
                            text: " Data Updated successfully.",
                            icon: "success",
                            confirmButtonText: 'Okay'
                        }).then(() => {
                            window.location.reload();
                        });

                    } else {
                        Swal.fire({
                            title: "Error",
                            text: resp.messages,
                            icon: "error"
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Error",
                        text: error,
                        icon: "error"
                    });
                });
        }



    };

    const handleBrokerageScriptDropdown = (selectedOption, id) => {
        setInputFields(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, selectedScript: selectedOption ? selectedOption.value : '' } : item
            )
        );
    };

    const inputChangeBrokerageDetails = (e, field, id) => {
        const value = e.target.value;
        setInputFields(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
        ]);
    };

    const handleRemoveField = (id) => {
        setInputFields(prevState => prevState.filter(item => item.id !== id));
    };
    const fieldsToRenderINDEX = inputFields.length === 0 ? [{ id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }] : inputFields;

    const handleBrokerageScriptDropdownNSE = (selectedOption, id) => {
        setInputFieldsNSE(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, selectedScript: selectedOption ? selectedOption.value : '' } : item
            )
        );
    };

    const inputChangeBrokerageDetailsNSE = (e, field, id) => {
        const value = e.target.value;
        setInputFieldsNSE(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleAddFieldsNSE = () => {
        setInputFieldsNSE([
            ...inputFieldsNSE,
            { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
        ]);
    };

    const handleRemoveFieldNSE = (id) => {
      setInputFieldsNSE((prevState) =>
        prevState.filter((item) => item.id !== id)
      );
    };
    const fieldsToRender = inputFieldsNSE.length === 0 ? [{ id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }] : inputFieldsNSE;

    const handleBrokerageScriptDropdownMCX = (selectedOption, id) => {
        setInputFieldsMCX(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, selectedScript: selectedOption ? selectedOption.value : '' } : item
            )
        );
    };

    const inputChangeBrokerageDetailsMCX = (e, field, id) => {
        const value = e.target.value;
        setInputFieldsMCX(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleAddFieldsMCX = () => {
        setInputFieldsMCX([
            ...inputFieldsMCX,
            { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
        ]);
    };

    const handleRemoveFieldMCX = (id) => {
        setInputFieldsMCX(prevState => prevState.filter(item => item.id !== id));
    };
    const fieldsToRenderMCX = inputFieldsMCX.length === 0 ? [{ id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }] : inputFieldsMCX;


    const handleBrokerageScriptDropdownNCDEX = (selectedOption, id) => {
        setInputFieldsNCDEX(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, selectedScript: selectedOption ? selectedOption.value : '' } : item
            )
        );
    };

    const inputChangeBrokerageDetailsNCDEX = (e, field, id) => {
        const value = e.target.value;
        setInputFieldsNCDEX(prevState =>
            prevState.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleAddFieldsNCDEX = () => {
        setInputFieldsNCDEX([
            ...inputFieldsNCDEX,
            { id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }
        ]);
    };

    const handleRemoveFieldNCDEX = (id) => {
        setInputFieldsNCDEX(prevState => prevState.filter(item => item.id !== id));
    };
    const fieldsToRenderNCDEX = inputFieldsNCDEX.length === 0 ? [{ id: Date.now(), selectedScript: '', deliveryCom: '', intradayCom: '' }] : inputFieldsNCDEX;


    const handleCopySettingDropdown = (selected) => {
        setSelectedOption(selected);
    };

    const handleSubBrokerDropdown = (selectedOption) => {
        setSelectedBroker(selectedOption);
    };
    const handleScriptDetailsDropdown = (selectedOptions) => {
        setScriptDeatailsDropdown(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const handleBlockedScriptDropdown = (selectedOptions) => {
        setBlockedScriptDropdown(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleRadioSelection = (selection) => {
        setMarginDetailsRadioSelection(selection);
        if (selection === 'LOT') {
            setMarginDetails({ lot: marginDetailsDelivery, amount: null });
        } else if (selection === 'AMOUNT') {
            setMarginDetails({ lot: null, amount: marginDetailsDelivery });
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setMarginDetailsDelivery(value);

        if (marginDetailsRadioSelection === 'LOT') {
            setMarginDetails({ lot: value, amount: null });
        } else if (marginDetailsRadioSelection === 'AMOUNT') {
            setMarginDetails({ lot: null, amount: value });
        }

    };
    const handleBrokerageScriptDropdwonMCX = (selectedOption) => {
        if (Array.isArray(selectedOption)) {
            setBrokerageDropdownMCX(selectedOption.map(option => option.value));
        } else {
            setBrokerageDropdownMCX(selectedOption ? [selectedOption.value] : []);
        }
    };
    const handleCopySettingDropdownMCX = (selected) => {
        setSelectedOptionMCX(selected);
    };

    const handleScriptDetailsDropdownMCX = (selectedOptions) => {
        setScriptDeatailsDropdownMCX(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const handleBlockedScriptDropdownMCX = (selectedOptions) => {
        setBlockedScriptDropdownMCX(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleRadioSelectionMCX = (selection) => {
        setMarginDetailsRadioSelectionMCX(selection);
        if (selection === 'LOT') {
            setMarginDetailsMCX({ lot: marginDetailsDeliveryMCX, amount: null });
        } else if (selection === 'AMOUNT') {
            setMarginDetailsMCX({ lot: null, amount: marginDetailsDeliveryMCX });
        }
    };

    const handleInputChangeMCX = (e) => {
        const value = e.target.value;
        setMarginDetailsDeliveryMCX(value);

        if (marginDetailsRadioSelectionMCX === 'LOT') {
            setMarginDetailsMCX({ lot: value, amount: null });
        } else if (marginDetailsRadioSelection === 'AMOUNT') {
            setMarginDetailsMCX({ lot: null, amount: value });
        }
    };


    const handleBrokerageScriptDropdwonNSE = (selectedOption) => {
        if (Array.isArray(selectedOption)) {
            setBrokerageDropdownNSE(selectedOption.map(option => option.value));
        } else {
            setBrokerageDropdownNSE(selectedOption ? [selectedOption.value] : []);
        }
    };
    const handleCopySettingDropdownNSE = (selected) => {
        setSelectedOptionNSE(selected);
    };

    const handleScriptDetailsDropdownNSE = (selectedOptions) => {
        setScriptDeatailsDropdownNSE(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const handleBlockedScriptDropdownNSE = (selectedOptions) => {
        setBlockedScriptDropdownNSE(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleRadioSelectionNSE = (selection) => {
        setMarginDetailsRadioSelectionNSE(selection);
        if (selection === 'LOT') {
            setMarginDetailsNSE({ lot: marginDetailsDeliveryNSE, amount: null });
        } else if (selection === 'AMOUNT') {
            setMarginDetailsNSE({ lot: null, amount: marginDetailsDeliveryNSE });
        }
    };

    const handleInputChangeNSE = (e) => {
        const value = e.target.value;
        setMarginDetailsDeliveryNSE(value);

        if (marginDetailsRadioSelectionNSE === 'LOT') {
            setMarginDetailsNSE({ lot: value, amount: null });
        } else if (marginDetailsRadioSelectionNSE === 'AMOUNT') {
            setMarginDetailsNSE({ lot: null, amount: value });
        }
    };

    const handleBrokerageScriptDropdwonNCDEX = (selectedOption) => {
        if (Array.isArray(selectedOption)) {
            setBrokerageDropdownNCDEX(selectedOption.map(option => option.value));
        } else {
            setBrokerageDropdownNCDEX(selectedOption ? [selectedOption.value] : []);
        }
    };
    const handleCopySettingDropdownNCDEX = (selected) => {
        setSelectedOptionNCDEX(selected);
    };

    const handleScriptDetailsDropdownNCDEX = (selectedOptions) => {
        setScriptDeatailsDropdownNCDEX(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };

    const handleBlockedScriptDropdownNCDEX = (selectedOptions) => {
        setBlockedScriptDropdownNCDEX(selectedOptions ? selectedOptions.map(option => option.value) : []);
    };
    const handleRadioSelectionNCDEX = (selection) => {
        setMarginDetailsRadioSelectionNCDEX(selection);
        if (selection === 'LOT') {
            setMarginDetailsNCDEX({ lot: marginDetailsDeliveryNCDEX, amount: null });
        } else if (selection === 'AMOUNT') {
            setMarginDetailsNCDEX({ lot: null, amount: marginDetailsDeliveryNCDEX });
        }
    };

    const handleInputChangeNCDEX = (e) => {
        const value = e.target.value;
        setMarginDetailsDeliveryNCDEX(value);

        if (marginDetailsRadioSelectionNCDEX === 'LOT') {
            setMarginDetailsNCDEX({ lot: value, amount: null });
        } else if (marginDetailsRadioSelectionNCDEX === 'AMOUNT') {
            setMarginDetailsNCDEX({ lot: null, amount: value });
        }
    };


    return (
      <div className="container-fluid mb-5">
        <Form onSubmit={(e) => doNewAccount(e)} id="signup-form">
          <input type="hidden" name="parentAdminId" value={adminId} />
          <input type="hidden" name="adminId" value={adminId} />
          <div>
            <Card>
              <Card.Body>
                <Row>
                  <Col xs={6} sm={3} xl={2}>
                    {isAddingSetting ? (
                      <Button
                        variant="danger"
                        className="fss-06 mt-4"
                        onClick={handleBackButtonClick}
                      >
                        <FaArrowLeft className="me-1" />
                        Back
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        className="fss-06 mt-4"
                        onClick={handleAddSettingClick}
                      >
                        Add Setting
                      </Button>
                    )}
                  </Col>
                  <Col xs={6} sm={3} xl={2}>
                    {/* Select Setting Text */}
                    {/* Conditionally render dropdown or input field */}
                    {isAddingSetting ? (
                      <>
                        <label htmlFor="settingName"> Setting Name</label>
                        <br />
                        <Form.Control
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          className="bg-white text-black custom-placeholder"
                          placeholder="Setting Name"
                          name="settingName"
                          size="sm"
                          value={formData.settingName}
                          onChange={handleChange}
                        />
                      </>
                    ) : (
                      <>
                        <label htmlFor="settingName"> Select Setting </label>
                        <br />
                        <Select
                          id="react-select"
                          value={selectedOptionDefault}
                          onChange={handleSelectChange}
                          options={optionsDefault}
                          placeholder="Select"
                          className=""
                          styles={customStyles}
                          theme={the}
                          isClearable
                        />
                      </>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
          {/* {selectedRole !== '' && selectedRole !== 'SELECT ROLE' && ( */}
          <div>
            <div id="customerAccountDetails">
              <Card className="mt-1 pt-0">
                <Card.Body className="pt-1">
                  <Row>
                    <lagend className="fieldset-legend-title label-color">
                      ACCOUNT DETAILS
                    </lagend>
                  </Row>
                  <div>
                    <Row className="mt-2">
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>ORDER BETWEEN HIGH LOW </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-1 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                label="YES"
                                name="orderHighLow"
                                value="YES"
                                type={type}
                                inline
                                checked={orderHighLow === true}
                                onChange={() => setOrderHighLow(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                type={type}
                                label="NO"
                                name="orderHighLow"
                                value="NO"
                                inline
                                checked={orderHighLow === false}
                                onChange={() => setOrderHighLow(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>APPLY AUTO SQUARE </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-1 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="YES"
                                name="applyAutoSquare"
                                value="YES"
                                type={type}
                                checked={applyAutoSquare === true}
                                onChange={() => setAutoSquare(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="applyAutoSquare"
                                value="NO"
                                type={type}
                                checked={applyAutoSquare === false}
                                onChange={() => setAutoSquare(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                    </Row>

                    <Row className="mt-0">
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>INTRA DAY AUTO SQUARE </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                type={type}
                                label="YES"
                                name="intraDayAutoSquare"
                                value="YES"
                                inline
                                checked={intraDayAutoSquare === true}
                                onChange={() => setIntraDayAutoSquare(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                type={type}
                                label="NO"
                                name="intraDayAutoSquare"
                                value="NO"
                                inline
                                checked={intraDayAutoSquare === false}
                                onChange={() => setIntraDayAutoSquare(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>

                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>ONLY POSITION SQUAREOFF</b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                type={type}
                                label="YES"
                                name="onlyPositionSquare"
                                value="YES"
                                inline
                                checked={onlyPositionSquareOff === true}
                                onChange={() => setOnlyPositionSquare(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                type={type}
                                label="NO"
                                name="onlyPositionSquare"
                                value="NO"
                                inline
                                checked={onlyPositionSquareOff === false}
                                onChange={() => setOnlyPositionSquare(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                    </Row>
                    <Row className="mt-0">
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>ROLL OVER </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                inline
                                label="YES"
                                name="rollOver"
                                value="YES"
                                type={type}
                                checked={rollOver === true}
                                onChange={() => setRollOver(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="rollOver"
                                value="NO"
                                type={type}
                                checked={rollOver === false}
                                onChange={() => setRollOver(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>ONLY VIEW ACCESS </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                inline
                                label="YES"
                                name="onlyViewAccess"
                                value="YES"
                                type={type}
                                checked={onlyViewAccess === true}
                                onChange={() => setOnlyViewAccess(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="onlyViewAccess"
                                value="NO"
                                type={type}
                                checked={onlyViewAccess === false}
                                onChange={() => setOnlyViewAccess(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                    </Row>

                    <Row className="mt-0">
                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>BAND SCRIPT ALLOW </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                inline
                                label="YES"
                                name="bandScripAllow"
                                value="YES"
                                type={type}
                                checked={bandScriptAllow === true}
                                onChange={() => setBandScriptAllow(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="bandScripAllow"
                                value="NO"
                                type={type}
                                checked={bandScriptAllow === false}
                                onChange={() => setBandScriptAllow(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>

                      <Col sm={3} xs={7} className="fss-875 label-color">
                        <b>M2M LINKED WITH LEDGER </b>
                      </Col>
                      <Col sm={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mb-1 ps-0 pe-0 text-right"
                                  : "ms-4 mb-3"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                inline
                                label="YES"
                                name="m2mLinkedWithLedger"
                                value="YES"
                                type={type}
                                checked={m2mLinkWithLedger === true}
                                onChange={() => setm2mLinkWithLedger(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="m2mLinkedWithLedger"
                                value="NO"
                                type={type}
                                checked={m2mLinkWithLedger === false}
                                onChange={() => setm2mLinkWithLedger(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                    </Row>

                    <Row className="mt-0">
                      <Col
                        sm={3}
                        xl={3}
                        xs={7}
                        className={
                          isMobile
                            ? "fss-875 label-color pt-1"
                            : "fss-875 label-color"
                        }
                      >
                        <b>TRADE ALLOWED </b>
                      </Col>
                      <Col sm={3} xl={3} xs={5}>
                        <Form>
                          {["radio"].map((type) => (
                            <div
                              key={`inline-${type}`}
                              className={
                                isMobile
                                  ? "mt-1 mb-3 ps-0 pe-0 text-right"
                                  : "ms-4 mb-1"
                              }
                            >
                              <Form.Check
                                className="custom-radio ps-0 pe-0 label-color fss-875"
                                inline
                                label="YES"
                                name="tradeAllowed"
                                value="YES"
                                type={type}
                                checked={tradeAllowed === true}
                                onChange={() => setTradeAllowed(true)}
                              />
                              <Form.Check
                                className="custom-radio label-color fss-875"
                                inline
                                label="NO"
                                name="tradeAllowed"
                                value="NO"
                                type={type}
                                checked={tradeAllowed === false}
                                onChange={() => setTradeAllowed(false)}
                              />
                            </div>
                          ))}
                        </Form>
                      </Col>
                      <Col sm={3} xl={3} xs={6} className="fss-875 label-color">
                        <b>ALERT (%) </b>
                      </Col>
                      <Col sm={2} xl={2} xs={6}>
                        <InputGroup size="sm">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white custom-placeholder value-color"
                            placeholder="ALERT(%)"
                            type="number"
                            name="alert"
                            value={formData.alert}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                alert: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                    </Row>

                    <Row className="pt-1">
                      <Col sm={3} xs={6} className="fss-875 label-color">
                        <b>ORDER LIMIT (%)</b>
                      </Col>
                      <Col sm={2} xs={6}>
                        <InputGroup size="sm">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white  custom-placeholder  value-color "
                            placeholder="OrderLimit(%)"
                            name="orderLimit"
                            type="number"
                            value={formData.orderLimit}
                            defaultValue={4}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                orderLimit: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                      <Col sm={1}></Col>
                      <Col sm={3} xs={6} className="fss-875 label-color">
                        <b>SQ. OFF DISABLED IN (MINUTES) </b>
                      </Col>
                      <Col sm={2} xs={6} className="mt-1">
                        <InputGroup size="sm">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white  value-color custom-placeholder"
                            placeholder="0"
                            type="number"
                            name="squareOffDisabledInMin"
                            value={formData.squareOffDisabledInMin}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                squareOffDisabledInMin: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>

                      <Col sm={1}></Col>
                    </Row>

                    <Row className="mt-0">
                      <Col
                        sm={3}
                        xl={3}
                        xs={6}
                        className="fss-875 label-color mt-1"
                      >
                        <b>M2M LOSS </b>
                      </Col>
                      <Col
                        sm={2}
                        xl={2}
                        xs={6}
                        className={!isMobile ? "mt-0" : "mt-1"}
                      >
                        <InputGroup size="sm ">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white  value-color custom-placeholder"
                            placeholder="M2M LOSS"
                            name="m2mLoss"
                            type="number"
                            value={formData.m2mLoss}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                m2mLoss: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                        {formData.m2mLoss ? (
                          <label className="word-color">
                            {" "}
                            {NumberToWordFormatter.numberToWordsIndian(
                              parseInt(formData.m2mLoss, 10)
                            )}{" "}
                          </label>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col sm={1}></Col>
                      <Col sm={3} xs={6} className="fss-875 label-color mt-1">
                        <b>M2M PROFIT </b>
                      </Col>
                      <Col sm={2} xs={6} className="mt-1">
                        <InputGroup size="sm ">
                          <Form.Control
                            type="number"
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white  value-color custom-placeholder"
                            placeholder="M2M PROFIT"
                            name="m2mProfit"
                            value={formData.m2mProfit}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                m2mProfit: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                        {formData.m2mProfit ? (
                          <label className="word-color">
                            {" "}
                            {NumberToWordFormatter.numberToWordsIndian(
                              parseInt(formData.m2mProfit, 10)
                            )}{" "}
                          </label>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>

                    <Row className="mt-1">
                      <Col sm={3} xs={6} className="fss-875 label-color">
                        <b>TRADE BLOCK ABOVE </b>
                      </Col>
                      <Col sm={2} xs={6}>
                        <InputGroup size="sm">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white  value-color custom-placeholder"
                            placeholder="Trade Block Above"
                            name="tradeBlockAbove"
                            type="number"
                            value={formData.tradeBlockAbove}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                tradeBlockAbove: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                        {formData.tradeBlockAbove ? (
                          <label className="word-color">
                            {" "}
                            {NumberToWordFormatter.numberToWordsIndian(
                              parseInt(formData.tradeBlockAbove, 10)
                            )}{" "}
                          </label>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col sm={1}></Col>
                      <Col sm={3} xs={6} className="fss-875 label-color mt-1">
                        <b>TRADE BLOCK BELOW </b>
                      </Col>
                      <Col sm={2} xs={6} className="mt-1">
                        <InputGroup size="sm">
                          <Form.Control
                            aria-label="Small"
                            aria-describedby="inputGroup-sizing-sm"
                            className="bg-white value-color custom-placeholder"
                            placeholder="Trade Block Below"
                            name="tradeBlockBelow"
                            type="number"
                            value={formData.tradeBlockBelow}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                tradeBlockBelow: e.target.value,
                              })
                            }
                          />
                        </InputGroup>
                        {formData.tradeBlockBelow ? (
                          <label className="word-color">
                            {" "}
                            {NumberToWordFormatter.numberToWordsIndian(
                              parseInt(formData.tradeBlockBelow, 10)
                            )}{" "}
                          </label>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div id="customerdetails">
              <Row className="mt-1">
                {selectedRole !== "SUBBROKER" && (
                  <>
                    <Col xs={12} xl={4}>
                      <Card>
                        <Card.Body className="pt-0">
                          <div>
                            <Row>
                              <lagend className="fieldset-legend-title label-color">
                                MARKET ACCESS
                              </lagend>
                            </Row>
                            <Row className="mt-1"></Row>
                            <Row>
                              {adminId.segments.includes("GLOBAL") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 1"
                                      type="checkbox"
                                      label="GLOBAL"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedGlobal}
                                      onChange={handleCheckboxChange}
                                      name="global"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedGlobal}
                                      onClick={handleOpenModal}
                                    >
                                      <b>
                                        GLOBAL <br /> Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("NSE") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 2"
                                      type="checkbox"
                                      label="NSE"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedNSE}
                                      onChange={handleCheckboxChange}
                                      name="nse"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedNSE}
                                      onClick={handleOpenModalNSE}
                                    >
                                      <b>
                                        NSE <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("MCX") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 3"
                                      type="checkbox"
                                      label="MCX"
                                      className="custom-checkbox label-color fss-875 "
                                      checked={isCheckedMCX}
                                      onChange={handleCheckboxChange}
                                      name="mcx"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedMCX}
                                      onClick={handleOpenModalMCX}
                                    >
                                      <b>
                                        MCX <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {/* {adminId.segments.includes("NCDEX") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 4"
                                      type="checkbox"
                                      label="NCDEX"
                                      className="custom-checkbox label-color fss-875 "
                                      checked={isCheckedNCDEX}
                                      onChange={handleCheckboxChange}
                                      name="ncdex"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07  w-auto market-access"
                                      disabled={!isCheckedNCDEX}
                                      onClick={handleOpenModalNCDEX}
                                    >
                                      <b>
                                        NCDEX <br /> Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null} */}

                              <Modal
                                show={showModal}
                                onHide={handleCloseModal}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    GLOBAL
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                              {fieldsToRenderINDEX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScripts
                                                          }
                                                          value={
                                                            brokerageScripts.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleBrokerageScriptDropdown(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetails(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetails(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputFields.length >
                                                              1 &&
                                                              inputFields.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveField(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFields
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                          
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelection ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={marginDetailsINDEXLot}
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINEDXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelection ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black"
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={
                                                    marginDetailsINDEXAmount
                                                  }
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINDEXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsIndexRadioSelection ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={scriptDetailsScript}
                                                  value={scriptDetailsScript.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownINDEX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsIndexRadioSelection ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={blockedScriptDetails}
                                                  value={blockedScriptDetails.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownIndex
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={indexScriptToWork}
                                                onChange={(e) => {
                                                  setIndexScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={indexFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setIndexFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModal}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              <Modal
                                show={showModalMCX}
                                onHide={handleCloseModalMCX}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    MCX
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col
                                      xl={5}
                                      className={`${
                                        !isMobile ? "ps-0 pe-0" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXorBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}

                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -5 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>

                                              <div>
                                              {fieldsToRenderMCX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionMCX
                                                          ) =>
                                                            handleBrokerageScriptDropdownMCX(
                                                              selectedOptionMCX,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsMCX(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsMCX(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                              {inputFieldsMCX.length >
                                                              1 &&
                                                              inputFieldsMCX.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldMCX(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsMCX
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                         
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={3}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                      xs={isMobile ? 12 : 0}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionMCX ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXLot}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionMCX ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXAmount}
                                                  // onChange={handleInputChangeMCX}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={4}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionMCX ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptMCX
                                                  }
                                                  value={scriptDetailsScriptMCX.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownMCX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionMCX ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsMCX
                                                  }
                                                  value={blockedScriptDetailsMCX.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownMCX
                                                  } // Handle selection change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={mcxScriptToWork}
                                                onChange={(e) => {
                                                  setMCXScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={mcxFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setMcxFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalMCX}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              <Modal
                                show={showModalNSE}
                                onHide={handleCloseModalNSE}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    NSE
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                              {fieldsToRender.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsNSE
                                                          }
                                                          value={
                                                            brokerageScriptsNSE.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionNSE
                                                          ) =>
                                                            handleBrokerageScriptDropdownNSE(
                                                              selectedOptionNSE,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          // isDisabled={
                                                          //   inputField.id === 1
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsNSE(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsNSE(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}

                                                            {/* {inputFieldsNSE.map(
                                                              (field) =>
                                                                inputField.id ===
                                                                  field.id &&
                                                                inputField.id !==
                                                                  1 ? (
                                                                  <span
                                                                    className="text-danger cursor-pointer"
                                                                    style={{
                                                                      fontSize:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "800",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleRemoveFieldNSE(
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  >
                                                                    ×
                                                                  </span>
                                                                ) : null
                                                            )} */}
                                                              {inputFieldsNSE.length >
                                                              1 &&
                                                              inputFieldsNSE.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldNSE(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsNSE
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                           
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionNSE ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSELot}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSELot(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSELot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSELot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionNSE ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSEAmount}
                                                  // onChange={handleInputChangeNSE}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSEAmount(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSEAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSEAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          {/* <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row> */}
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionNSE ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptNSE
                                                  }
                                                  value={scriptDetailsScriptNSE?.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter based on the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownNSE
                                                  } // Handle change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionNSE ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsNSE
                                                  }
                                                  value={blockedScriptDetailsNSE?.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownNSE
                                                  } // Handle changes
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={NseScriptToWork}
                                                onChange={(e) => {
                                                  setNSEScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={nseFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setNseFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalNSE}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </Row>
                            <Row>
                              <Col></Col>
                              <Col></Col>
                              <Col></Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </>
                )}
                <Col xs={12} xl={4} className="mt-1">
                  <Card>
                    <Card.Body className="pt-0">
                      <div>
                        <Row>
                          <lagend className="fieldset-legend-title label-color">
                            USER NOTES
                          </lagend>
                        </Row>
                        <Row className="ms-1 me-1">
                          <Form.Control
                            as="textarea"
                            type="text"
                            className="mt-2  bg-white custom-placeholder value-color"
                            placeholder="Enter Remark"
                            name="remark"
                          />
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
            <div className="text-center">
              <Button
                className="mt-3 w-25"
                variant="success"
                type="submit"
                disabled={
                  formData.settingName === null || formData.settingName === ""
                } // Disable if settingName is null or empty
              >
                SUBMIT
              </Button>
            </div>
            <Row className="mt-5"></Row>
          </div>
          {/* )} */}
        </Form>
      </div>
    );

}
export default Defaultsetting; 